export default __webpack_public_path__ + "static/media/view-app-arrow-black.08a43a8a.svg";